<div class="no-data-content">
  <div class="no-data">
    <img [src]="image" />
    <p
      [translatable]="{
        transKey: _msgTranslationKey,
        modEnum: _selectedTranslatioModuleEnum
      }"
    >
      {{ _msg | translate}}   
    </p>
  </div>
</div>

